let RESOURCE_CONFIGS = {
  DATE_TIME: {
    DEFAULT_FORMAT: 'DD-MMM-YYYY',
    DATE_WITH_TIME: 'DD-MMM-YYYY HH:mm',
    DATE_TIME_WITH_SECONDS: 'DD-MMM-YYYY HH:mm:ss',
    AUCTION_TIME_FORMAT: 'DD-MMM-YYYY HH:mm:ss',
    DATE_ONLY: 'YYYY-MM-DD',
    TIME_ONLY: 'HH:mm',
  },

  RESPONSIVE_BREAKPOINTS: {
    SM: '576px',
    MD: '991px',
    LG: '1200px',
  },
};

export default RESOURCE_CONFIGS;
